import { render, staticRenderFns } from "./TrademarkObjectionToUsDecision.vue?vue&type=template&id=a5f9d460&"
import script from "./TrademarkObjectionToUsDecision.vue?vue&type=script&lang=js&"
export * from "./TrademarkObjectionToUsDecision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports